import React, { useEffect, useRef, useState } from 'react';
import { t } from '../../../utilities/translator';
import useDebounce from '../../../hooks/useDebounce';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
import useGetSearchResults from '../../mainFilter/filters/Destination/useGetSearchResults';
import { highlightBoldText } from '../../../utilities/helpers';
import { useSelector } from 'react-redux';
import SearchResultLoader from '../../../components/loaders/SearchResultLoader';

const SearchByHotel = ({ destinationIds, onSelectHotel, selectedHotel }) => {
  const searchRef = useRef(null);
  const searchHotelLineRef = useRef(null);
  const [searchValue, setSearchValue] = useState('');
  const [label, setLabel] = useState(selectedHotel?.hotelName ? selectedHotel.hotelName : '');
  const { selectedHotel: stateSelected, ...search } = useSelector(state => state.userSearch);
  const debounceValue = useDebounce(searchValue, 500);
  const [showDropdown, setShowDropdown] = useState(false);
  const { hotels } = useGetSearchResults(debounceValue, destinationIds);

  useOnClickOutside(searchRef, () => {
    if (showDropdown) {
      setShowDropdown(false);
    }
  });

  useEffect(() => {
    if (selectedHotel?.hotelName) {
      setLabel(selectedHotel.hotelName);
    } else {
      setLabel('');
      setSearchValue('');
    }
  }, [selectedHotel])

  useEffect(() => {
    if (showDropdown) {
      searchRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [showDropdown, hotels])

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
    setLabel(event.target.value);
    if (!showDropdown) {
      setShowDropdown(true);
    }
  }

  const handleHotelClick = (hotel) => {
    setShowDropdown(false);
    onSelectHotel(hotel);
    setLabel(hotel.hotelName);
  }

  const handleSearchInputClick = () => {
    if (hotels.length > 0) {
      setShowDropdown(true);
    }
  }

  const handleSearchHotelLineClick = () => {
    // searchHotelLineRef.current.focusInput();
    if (searchHotelLineRef.current) {
      searchHotelLineRef.current.focus();
      const filterBlock = document.querySelector('.panel-body');
      if (filterBlock) {
        filterBlock.scrollTop = filterBlock.scrollHeight;
      }
    }
  }

  const onClearSearch = () => {
    onSelectHotel(null);
    setSearchValue('');
    setLabel('');
  }

  return (
    <>
      <div
        className="customize-hotel-search body-medium"
        dangerouslySetInnerHTML={{ __html: t('customize.hotelSearch') }}
        onClick={handleSearchHotelLineClick}
      />
      <div ref={searchRef}>
        <div className="search-input relative">
          {selectedHotel?.hotelName && (
            <i className="clear-search ri-close-line text-2xl absolute top-2 right-4" onClick={onClearSearch} />
          )}
          <input
            type="text"
            className="w-full border-none ps-11 pe-4 py-4 rounded-xl body-medium"
            placeholder={t('destinations.searchByHotelPlaceholder')}
            onChange={handleSearchChange}
            value={label}
            onClick={handleSearchInputClick}
            ref={searchHotelLineRef}
          />
        </div>
        {showDropdown && (
          <div className="flex flex-col gap-4 mt-1 p-5 bg-white rounded-xl max-h-60 overflow-auto">
            {search.state === 'loading' ? (
              <>
                <SearchResultLoader />
                <SearchResultLoader />
                <SearchResultLoader />
              </>
            ) : (
              hotels.map(hotel => (
              <div className="flex gap-2" key={hotel.hotelId} onClick={() => handleHotelClick(hotel)}>
                <i className="ri-hotel-line" />
                <div>
                  <div className="body-medium leading-none" dangerouslySetInnerHTML={{ __html: highlightBoldText(hotel.hotelName, label)}} />
                  <span className="body-mini leading-none text-gray-400">{hotel.hfDestinationName}</span>
                </div>
              </div>
            )))}
          </div>
        )}
      </div>
    </>
  )
}

export default SearchByHotel
